(function() {
  function initHeroSlider(slider) {
    const slides = Array.from(slider.querySelectorAll('.hero-slider__slide'));
    if (slides.length <= 1) return;

    const ticks = Array.from(slider.querySelectorAll('.hero-slider__tick'));
    const prevBtn = slider.querySelector('.hero-slider__arrow--prev');
    const nextBtn = slider.querySelector('.hero-slider__arrow--next');
    const counterCurrent = slider.querySelector('.hero-slider__counter-current');
    
    // Create aria-live region for screen reader announcements
    let liveRegion = slider.querySelector('.hero-slider__live-region');
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.className = 'hero-slider__live-region';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.className = 'visually-hidden';
      slider.appendChild(liveRegion);
    }
    
    let currentIndex = 0;
    let timer = null;
    let isPaused = false;
    let pauseTimeout = null;
    
    const autoplaySeconds = parseFloat(slider.dataset.autoplay) || 6;
    const autoplayMs = autoplaySeconds * 1000;
    
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function announceSlide(index) {
      const slideTitle = slides[index].querySelector('.hero-slider__title');
      if (liveRegion && slideTitle) {
        liveRegion.textContent = 'Slide ' + (index + 1) + ' of ' + slides.length + ': ' + slideTitle.textContent;
      }
    }

    function goToSlide(index) {
      if (index === currentIndex) return;
      
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      
      slides[currentIndex].classList.remove('is-active');
      slides[index].classList.add('is-active');
      
      if (ticks.length) {
        ticks[currentIndex].classList.remove('is-active');
        ticks[index].classList.add('is-active');
        ticks[currentIndex].setAttribute('aria-selected', 'false');
        ticks[index].setAttribute('aria-selected', 'true');
      }
      
      if (counterCurrent) {
        counterCurrent.textContent = String(index + 1).padStart(2, '0');
      }
      
      // Pause videos on departing slide
      const prevVideos = slides[currentIndex].querySelectorAll('video');
      prevVideos.forEach(function (v) {
        try { if (!v.paused) v.pause(); } catch (e) {}
      });

      // Play video on arriving slide, from the start
      const nextVideos = slides[index].querySelectorAll('video');
      nextVideos.forEach(function (v) {
        try {
          try { v.currentTime = 0; } catch (e) {}
          if (v.getAttribute('preload') === 'none') {
            v.setAttribute('preload', 'metadata');
          }
          var playPromise = v.play();
          if (playPromise !== undefined) {
            playPromise.catch(function () {});
          }
        } catch (e) {}
      });

      currentIndex = index;
      announceSlide(index);
      if (timer !== null) scheduleNext();
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    // Video slides advance when their video ends (the active video does not loop);
    // a generous fallback timer covers videos that stall. Image slides use the
    // section autoplay setting.
    function visibleVideo(index) {
      return Array.from(slides[index].querySelectorAll('video')).find(function (v) { return v.getClientRects().length; });
    }

    function scheduleNext() {
      if (timer) clearTimeout(timer);
      const index = currentIndex;
      const v = visibleVideo(index);
      if (v) {
        if (v.ended) { timer = setTimeout(nextSlide, 400); return; }
        v.loop = false;
        v.onended = function () { if (currentIndex === index && timer !== null) nextSlide(); };
        // Start as soon as the video can play (autoplay otherwise waits for a bigger buffer)
        const kick = function () { if (currentIndex === index && v.paused) { const p = v.play(); if (p) p.catch(function () {}); } };
        if (v.readyState >= 2) kick(); else v.addEventListener('canplay', kick, { once: true });
        // Once it is really playing, re-time the safety timer from where it is
        v.onplaying = function () {
          if (currentIndex !== index || timer === null || !isFinite(v.duration)) return;
          clearTimeout(timer);
          timer = setTimeout(nextSlide, (v.duration - v.currentTime) * 1300 + 4000);
        };
        const known = isFinite(v.duration) && v.duration > 1;
        timer = setTimeout(nextSlide, known ? v.duration * 1500 + 5000 : autoplayMs * 5);
        if (!known) v.addEventListener('loadedmetadata', function () { if (currentIndex === index && timer !== null) scheduleNext(); }, { once: true });
        return;
      }
      timer = setTimeout(nextSlide, autoplayMs);
    }

    function startTimer() {
      if (prefersReducedMotion) return;
      stopTimer();
      timer = -1;
      scheduleNext();
    }

    function stopTimer() {
      if (timer && timer !== -1) clearTimeout(timer);
      timer = null;
    }

    function handleInteraction() {
      stopTimer();
      if (pauseTimeout) clearTimeout(pauseTimeout);
      pauseTimeout = setTimeout(() => {
        startTimer();
      }, Math.max(6000, autoplayMs));
    }

    // Click listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevSlide();
        handleInteraction();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextSlide();
        handleInteraction();
      });
    }

    ticks.forEach((tick, idx) => {
      tick.addEventListener('click', () => {
        goToSlide(idx);
        handleInteraction();
      });
    });

    // Keyboard navigation
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        prevSlide();
        handleInteraction();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        nextSlide();
        handleInteraction();
      }
    });

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 50;

    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    slider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
        handleInteraction();
      }
    }, { passive: true });

    // (No pause-on-hover: the hero fills the screen, so the cursor is almost
    // always over it and slides would never advance.)

    // Initialize
    if (ticks.length) {
      ticks.forEach((t, i) => t.setAttribute('aria-selected', i === 0 ? 'true' : 'false'));
    }
    startTimer();
    
    slider.heroSliderAPI = {
      destroy: () => {
        stopTimer();
        if (pauseTimeout) clearTimeout(pauseTimeout);
      }
    };
  }

  function initAll() {
    document.querySelectorAll('.hero-slider').forEach(slider => {
      if (!slider.heroSliderAPI) {
        initHeroSlider(slider);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (e) => {
    const slider = e.target.querySelector('.hero-slider');
    if (slider) {
      initHeroSlider(slider);
    }
  });
})();